import * as React from 'react';
import {ModelHttpService} from '../components/services/modelHttp';
import {ModelName} from '../models/names';
import {UserContext} from './user';

export enum ImageActionType {
	FetchImages = 'FetchImages',
	SetImages = 'SetImages',
	RemoveImage = 'RemoveImage',
	DoneRemovingImage = "DoneRemovingImage",
	UpdateImage = 'UpdateImage'
}
type Action = {type: ImageActionType, payload?: any}

const initialState = {
	loading: true,
	fetching: false,
	items: [] as IImage[],
	remove: null as null | IImage,
}
export const ImageContext = React.createContext({
	...initialState,
	dispatch: (_: Action) => {}
})

export function ImageProvider(props: {children?: React.ReactNode}) {

	const user = React.useContext(UserContext);
	const project = user.currentProject as IProject;
	const [state, dispatch] = React.useReducer(reducer, initialState);

	// Reducer sideeffects
	React.useEffect(() => void fetchImages(), [state.fetching])
	React.useEffect(() => void removeImage(), [state.remove])

	// The reducer takes care of state updates.
	function reducer(state: typeof initialState, action: Action) {
		switch (action.type) {
			case ImageActionType.FetchImages:
				return {...state, loading: true, fetching: true}
			case ImageActionType.SetImages:
				return {...state, loading: false, items: action.payload, fetching: false}
			case ImageActionType.RemoveImage:
				return {...state, loading: true, remove: action.payload}
			case ImageActionType.DoneRemovingImage:
				return {...state, loading: false, remove: null}
			case ImageActionType.UpdateImage:
				updateImage(action.payload)
				const items = state.items.reduce((acc, i) => {
					if (i._id == action.payload._id)
						acc.push(action.payload)
					else
						acc.push(i)
					return acc
				}, [] as IImage[])
				return {...state, items}
			default:
				return state
		}
	}

	// Updates a single document
	async function updateImage(document: IImage) {
		const http = new ModelHttpService
		await http.update(ModelName.Image, document)
	}

	// Remove document from database
	async function removeImage(){
		if (state.remove == null) return
		const http = new ModelHttpService;
		try {
			await http.delete(ModelName.Image, state.remove)
			const payload = state.items.filter((i: IImage) => i !== state.remove)
			dispatch({type: ImageActionType.SetImages, payload})
		} catch (err) {
			console.error(err)
		} finally {
			dispatch({type: ImageActionType.DoneRemovingImage})
		}
	}

	// Fetch all documents from the database that belongs to currentProject
	async function fetchImages() {
		if (state.fetching == false) return
		const http = new ModelHttpService;
		const payload = await http.find<IImage>(ModelName.Image, {project: project._id} as Partial<IImage>);
		dispatch({type: ImageActionType.SetImages, payload})
	}

	return (
		<ImageContext.Provider value={{...state, dispatch}}>
			{props.children}
		</ImageContext.Provider>
	)
}

